import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useEffect, useMemo, useState } from "react";
import block from "bem-cn-lite";
import { Button, Select, Text, TextInput, Loader } from "@gravity-ui/uikit";
import { Check } from "@gravity-ui/icons";
import { getStatusIcon } from "./utils/getStatusIcon";
import "./SharedSelect.scss";
const b = block("shared-select-orders");
export const SharedSelect = ({ placeholder, size, hasClear, multiple = false, filterable = false, hasCounter = false, options, className, onApply, onCancel, onReset, isStatusSelect = false, filters, filterType, onFilterSuggestionsLoaded, fetchSuggestions, getLabel, isDataLoaded, isLoading, onLoadData, handleLoadMore, hasMore, onSearchInputChange, onOpenChangeOutside, }) => {
    const [selectedValues, setSelectedValues] = useState([]);
    const [open, setOpen] = useState(false);
    const [filterValue, setFilterValue] = useState("");
    const selectedOptions = useMemo(() => {
        return (options ?? []).filter((x) => x.isSelected).map((x) => x.value);
    }, [options]);
    const filteredOptions = (options ?? []).filter((option) => option.label.toLowerCase());
    useEffect(() => {
        if (!filterValue)
            return;
        if (!fetchSuggestions || !filterType || !onFilterSuggestionsLoaded)
            return;
        fetchSuggestions(filterType, filterValue).then((suggestions) => {
            onFilterSuggestionsLoaded(suggestions);
        });
    }, [filterValue]);
    useEffect(() => {
        if (JSON.stringify(selectedValues) !== JSON.stringify(selectedOptions)) {
            setSelectedValues(selectedOptions);
        }
    }, [selectedOptions]);
    const handleReset = () => {
        setSelectedValues([]);
        onReset?.();
    };
    const handleApply = () => {
        onApply?.(selectedValues);
        setOpen(false);
    };
    const handleCancel = () => {
        onCancel?.();
        setOpen(false);
    };
    function handleUpdate(value) {
        setSelectedValues(value);
        if (!multiple && onApply)
            onApply(value);
        if (!open && onApply)
            onApply(value);
    }
    const renderSelectedOption = (option) => {
        const { data } = option;
        if (multiple && selectedValues.length > 1) {
            return _jsx(Fragment, {});
        }
        return (_jsx("span", { className: "g-select-control__option-text", children: data?.label }));
    };
    function handleOpenChange(isOpen) {
        setOpen(isOpen);
        if (isOpen && !isDataLoaded && !isLoading) {
            onLoadData?.();
        }
        onOpenChangeOutside?.(isOpen);
    }
    return (_jsx(Select, { open: open, onOpenChange: handleOpenChange, value: selectedValues, placeholder: placeholder, size: size, hasClear: hasClear, multiple: multiple, filterable: filterable, hasCounter: multiple && selectedValues.length > 1, className: `${className} ${multiple && selectedValues.length > 1 ? "multiple-selected" : ""}`, popupWidth: "fit", onUpdate: handleUpdate, label: multiple && selectedValues.length > 1
            ? getLabel &&
                getLabel(filters, options, selectedValues)
            : undefined, loading: true && hasMore, onLoadMore: handleLoadMore, renderSelectedOption: renderSelectedOption, renderEmptyOptions: () => {
            if (isLoading) {
                return (_jsx("div", { className: b("loader-options"), children: _jsx(Loader, { size: "s" }) }));
            }
            if (isDataLoaded) {
                return _jsx("div", { className: b("empty-options"), children: "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" });
            }
            return _jsx(_Fragment, {});
        }, renderPopup: ({ renderList, renderFilter }) => {
            const hasOptions = filteredOptions.length > 0;
            return (_jsxs("div", { className: b(), children: [filterable && (_jsx("div", { className: b("header-search"), children: renderFilter() })), multiple && onReset && isStatusSelect && (_jsx("div", { className: b("header-button"), children: _jsx(Button, { view: "outlined", className: b("button-outlined"), size: "m", onClick: handleReset, children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0435" }) })), renderList(), hasOptions && (_jsxs("div", { className: b("footer-button"), children: [onCancel && (_jsx(Button, { size: "l", onClick: handleCancel, className: b("button-cancel"), style: {
                                    width: onApply ? "50%" : "auto",
                                }, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })), multiple && onApply && (_jsx(Button, { view: "action", size: "l", onClick: handleApply, children: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C" }))] }))] }));
        }, renderFilter: (props) => (_jsx(TextInput, { placeholder: "\u041F\u043E\u0438\u0441\u043A", value: props.value, onChange: (event) => {
                // Вызов стандартных обработчиков от Select
                props.onChange(event.target.value);
                // Локально сохраняем введённый текст
                setFilterValue(event.target.value);
                // Вызываем наружный колбэк
                onSearchInputChange?.(event.target.value);
            }, onKeyDown: props.onKeyDown, controlRef: props.ref, style: props.style })), children: filteredOptions.map((option) => {
            const isSelected = selectedValues.includes(option.value);
            let textColor = "primary";
            if (isStatusSelect) {
                switch (option.value) {
                    case "Выдан":
                        textColor = "positive-heavy";
                        break;
                    case "Отказ":
                        textColor = "danger-heavy";
                        break;
                    default:
                        textColor = "misc-heavy";
                }
            }
            return (_jsx(Select.Option, { value: option.value, text: option.label, data: option, children: _jsxs("div", { style: {
                        paddingLeft: !multiple && !isSelected ? "30px" : "0",
                    }, children: [!multiple && isSelected && (_jsx(Check, { style: {
                                marginRight: "14px",
                                color: "rgba(189, 142, 75, 1)",
                                verticalAlign: "middle",
                            } })), isStatusSelect && getStatusIcon(option.value), _jsx(Text, { color: textColor, children: option.label })] }) }, option.value));
        }) }));
};
